import { RELATED_SERVICE_ITEM_IN_VIEWPORT } from 'features/related-services';
import { getRelatedServices } from 'features/related-services/ducks/selectors';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { EffectR } from 'types/utils';
import { createAction } from 'typesafe-actions';
import {
  CompareCategory,
  isProductSet,
  selectCompareCategory,
  selectProductBrand,
} from '../../../product-info';
import { selectProductId } from '../selectors';
import { ViewsModels } from '../../../related-services/types';

/**
 * Cобытие должно срабатывать при попадании услуги во viewport.
 *
 * @see https://docs.google.com/document/d/1rdaDo_lgIIxoOgSocvCEtCk-kazxZirnyQzQ7uuhfog/edit
 */
export const gaViewService = createAction('GA:impressions')<{
  elementType: 'service';
  elementBlock: 'productDetail / services' | 'komplektyDetail / services'; // блок, в котором расположен элемент

  productName: string; // название услуги
  productId: string; // id услуги
  productPrice: string; // цена услуги
  productPosition: string; // позиция слева-направо и сверху-вниз от 1
  productBelong: 'LeroyMerlinServices'; // константа, всегда 'LeroyMerlinServices'
  category?: string;
  brand?: string | null;
  komplektyId: string | null;
}>();

export function* putGaViewService(title: string, serviceId: string, price: string, position: string) {
  const brand = (yield call(selectProductBrand)) as string;
  const compareCategory = (yield call(selectCompareCategory)) as CompareCategory;
  const isSet: boolean = yield select(isProductSet);
  const komplektyId: string = yield call(selectProductId);

  yield put(
    gaViewService({
      elementType: 'service',
      elementBlock: isSet ? 'komplektyDetail / services' : 'productDetail / services',
      productName: title.trim(),
      productId: serviceId,
      productPrice: price,
      productPosition: position,
      productBelong: 'LeroyMerlinServices',
      category: compareCategory?.name || '',
      brand,
      komplektyId: isSet ? komplektyId : null,
    }),
  );
}

export function* runGaViewServiceDetector() {
  yield takeEvery(RELATED_SERVICE_ITEM_IN_VIEWPORT, function* handle({ payload }) {
    const servicesArr = (yield select(getRelatedServices)) as EffectR.Select<typeof getRelatedServices>;
    let indexInView = 0;
    let serviceInView: ViewsModels.RelatedService | null = null;
    servicesArr.some((service, index) => {
      if (service.serviceId === payload) {
        indexInView = index;
        serviceInView = service;
        return true;
      }
      return false;
    });
    if (serviceInView as unknown as ViewsModels.RelatedService) {
      yield putGaViewService(
        `${serviceInView!.title}`,
        `${serviceInView!.serviceId}`,
        `${serviceInView!.price.value}`,
        `${indexInView + 1}`,
      );
    }
  });
}
